import { StyleSheet, View } from 'react-native';

import {
  IconCartOutline,
  MonetaryAmountOptionSelector,
  Text,
  XStack,
  YStack,
  tokens,
} from '@fhs/ui';

import { getReloadAmountOptions } from './utils';

type GiftCardReloadAmountSelectProps = {
  amountDueInCents: number;
  selectedReloadAmount: string;
  otherReloadAmount: string;
  onSelectReloadAmount: (value: string) => void;
  onChangeOtherReloadAmount: (value: string) => void;
};

export const GiftCardReloadAmountSelect = ({
  amountDueInCents,
  selectedReloadAmount,
  otherReloadAmount,
  onSelectReloadAmount,
  onChangeOtherReloadAmount,
}: GiftCardReloadAmountSelectProps) => {
  const amountOptions = getReloadAmountOptions(amountDueInCents);

  return (
    <YStack>
      <XStack style={styles.reloadTextWrapper}>
        <View style={styles.iconCircle}>
          <IconCartOutline size={24} color={tokens.colors.$houseDark} />
        </View>
        <Text>Reload Amount</Text>
      </XStack>
      <YStack style={styles.amountSelectorContainer}>
        <MonetaryAmountOptionSelector
          amountOptions={amountOptions}
          value={selectedReloadAmount}
          amountCents={0}
          onSelect={onSelectReloadAmount}
          otherValue={otherReloadAmount}
          onChangeOtherValue={onChangeOtherReloadAmount}
          hideAmountPreview
          showHeaderRow={false}
        />
      </YStack>
    </YStack>
  );
};

const styles = StyleSheet.create({
  reloadTextWrapper: {
    gap: 12,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  amountSelectorContainer: {
    flex: 1,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 100,
    gap: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$blackOpacity04,
  },
});
